module.exports = __webpack_public_path__ + "assets/img/E-4b3d3c9c.png";